/**
 * Extracts initials from a display name
 * @param displayName - The full display name
 * @returns Initials (up to 2 characters)
 */
export const getInitials = (displayName?: string): string => {
  if (!displayName) return 'U';
  
  const parts = displayName.trim().split(/\s+/);
  
  if (parts.length === 0) return 'U';
  if (parts.length === 1) return parts[0][0]?.toUpperCase() || 'U';
  
  // Get first letter of first name and first letter of last name
  const firstInitial = parts[0][0]?.toUpperCase() || '';
  const lastInitial = parts[parts.length - 1][0]?.toUpperCase() || '';
  
  return firstInitial + lastInitial;
};

/**
 * Generates a consistent background color based on the display name
 * Uses colors that fit with the Talk to Tally color palette
 */
export const getAvatarColor = (displayName?: string): string => {
  if (!displayName) return '#042434'; // Default Talaera blue
  
  // Color palette that fits with Talk to Tally theme
  const colors = [
    '#042434', // Talaera blue (dark)
    '#0066CC', // Talaera blue (medium)
    '#4A90E2', // Light blue
    '#7B68EE', // Medium slate blue (similar to Tally's gradient)
    '#9370DB', // Medium purple (from Tally's gradient)
    '#BA55D3', // Medium orchid
    '#00CED1', // Dark turquoise (from Tally's gradient)
    '#20B2AA', // Light sea green
    '#FF69B4', // Hot pink (from Tally's gradient)
    '#FF6B9D', // Light coral pink
  ];
  
  // Generate a consistent index based on the name
  let hash = 0;
  for (let i = 0; i < displayName.length; i++) {
    hash = displayName.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  return colors[Math.abs(hash) % colors.length];
};